module.exports = __webpack_public_path__ + "static/media/road_bike.17473c19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Explore/images/road_bike.jpg
// module id = 1598
// module chunks = 0